/**
 * LoadingSpinner - Wrapper around @agion/ui Spinner for backward compatibility
 */
import React from 'react'
import { Spinner, cn } from '@agion/ui'

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

// Map old sizes to new design system sizes
const sizeMap = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
} as const

export function LoadingSpinner({ size = 'medium', className = '' }: LoadingSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <Spinner size={sizeMap[size]} />
    </div>
  )
}
